<template>
  <!--  个人信息区块最外层盒子 w%100  -->
  <div class="personal-container">
    <!--  个人信息内容 w1200  -->
    <div class="personal">
      <!-- 账户和安全 - 开始 -->
      <div class="account-info">
        <div class="account-info-title-wrap">
          <h2 class="account-info-title">{{ $t('账户和安全') }}</h2>
          <h3 class="account-info-subtitle">
            <span class="last-login-time">
              {{ $t('最后登录时间：') }}{{ userInfo.lastLoginTime }}
            </span>
            <router-link to="/securitylog" class="goto-safe-log-btn">{{
              $t('查看安全记录')
            }}</router-link>
          </h3>
        </div>

        <!-- <Alert class="account-info-alert" type="warning" show-icon>
          {{ $t('安全提示') }}：{{
            $t(
              '为了您的账户安全，请检查访问地址，开启安全认证，不要透露短信和谷歌验证码给任何人，包括客服'
            )
          }}
        </Alert> -->

        <div class="account-content">
          <div class="account-content-item account-content-username">
            <h4>UID</h4>
            <span>{{ userInfo.userId }}</span>
          </div>

          <div class="account-content-item account-content-phone">
            <h4>{{ $t('手机号码') }}</h4>
            <a
              href="javascript:;"
              v-if="!userInfo.phone"
              class="email-verify-btn"
              @click="showModalHandle('phone')"
            >
              {{ $t('绑定手机号') }} >
            </a>
            <span v-else>{{ userInfo.phone }}</span>
          </div>

          <div class="account-content-item account-content-email">
            <h4>{{ $t('邮箱') }}</h4>
            <a
              href="javascript:;"
              v-if="!userInfo.email"
              class="email-verify-btn"
              @click="showModalHandle('email')"
              >{{ $t('绑定邮箱') }} >
            </a>
            <span v-else>{{ userInfo.email }}</span>
          </div>
          <div class="account-content-item account-content-email">
            <h4>{{ $t('资金密码') }}</h4>
            <a
              href="javascript:;"
              class="email-verify-btn"
              @click="showModalHandle('fundPass')"
              >{{ userInfo.isTrade ? $t('去修改') : $t('去设置') }} >
            </a>
            <span></span>
          </div>
          <div class="account-content-item account-content-email">
            <h4>{{ $t('登录密码') }}</h4>
            <a
              href="javascript:;"
              class="email-verify-btn"
              @click="showModalHandle('loginPass')"
            >
              {{ $t('去修改') }} >
            </a>
          </div>
        </div>
      </div>

      <!-- 模态框 - 开始 -->
      <component :is="modalComp.email" v-model="modalVis.email"></component>
      <component
        :is="modalComp.loginPass"
        v-model="modalVis.loginPass"
      ></component>
      <!-- :from="from" -->
      <component
        :is="modalComp.fundPass"
        v-model="modalVis.fundPass"
      ></component>
      <component :is="modalComp.phone" v-model="modalVis.phone"></component>
      <component
        :is="modalComp.modifyPhone"
        v-model="modalVis.modifyPhone"
      ></component>
      <component
        :is="modalComp.googleVerify"
        v-model="modalVis.googleVerify"
      ></component>
      <!-- 模态框 - 结束 -->

      <!-- 安全验证模态框 - 开始 -->
      <component
        :is="modalComp.loginPassVerify"
        v-model="modalVis.loginPassVerify"
      ></component>
      <component
        :is="modalComp.fundPassVerify"
        v-model="modalVis.fundPassVerify"
      ></component>
      <component
        :is="modalComp.openOrCloseVerify"
        v-model="modalVis.openOrCloseVerify"
      ></component>
      <!-- 安全验证模态框 - 结束 -->

      <!-- 开启手机 google 邮箱验证 - 开始 -->
      <component
        :is="modalComp.openPhoneVerify"
        v-model="modalVis.openPhoneVerify"
      ></component>
      <component
        :is="modalComp.openGoogleVerify"
        v-model="modalVis.openGoogleVerify"
      ></component>
      <component
        :is="modalComp.openEmailVerify"
        v-model="modalVis.openEmailVerify"
      ></component>
      <!-- 开启手机 google 邮箱验证 - 结束 -->
    </div>
  </div>
</template>

<script>
// 混入模态框组件
import modal from './Modal/modal.js'
import { updateUserInfo } from '@/utils'
// import { ajax_delOftenAddress, ajaxGet_getOftenIP } from '@/api/personal'
import { mapState } from 'vuex'

export default {
  name: 'Personal',
  data() {
    return {
      // from: '',
      safeIconArr: [
        require('@/assets/images/gantan-icon.png'),
        require('@/assets/images/zhengque-icon.png')
      ], // 存放安全提示图标
      modalComp: {
        // 用于模态框按需加载占位
        email: null,
        loginPass: null,
        fundPass: null,
        phone: null,
        modifyPhone: null,
        switchPhone: null,
        googleVerify: null,
        loginPassVerify: null, // 修改登录密码安全验证组件
        fundPassVerify: null, // 修改资金密码安全验证组件
        openOrCloseVerify: null, // 打开或关闭安全验证
        openPhoneVerify: null, // 开启手机验证
        openGoogleVerify: null, // 开启谷歌验证
        openEmailVerify: null // 开启邮箱验证
      },
      modalVis: {
        // 专门用于控制模态框状态
        loginPass: false, // 登录密码模态
        fundPass: false, // 资金密码模态
        email: false, // 验证邮箱模态框
        phone: false, // 验证手机模态框
        modifyPhone: false, // 修改手机模态框验证
        switchPhone: false, // 开关手机安全验证
        googleVerify: false, // 开关 google 验证
        loginPassVerify: false, // 开关修改登录密码模态框
        fundPassVerify: false, // 开关修改资金密码模态框
        openOrCloseVerify: false, // 打开或关闭安全验证
        openPhoneVerify: false, // 开启手机验证
        openGoogleVerify: false, // 开启谷歌验证
        openEmailVeriy: false // 开启邮箱验证
      },
      inputInfo: {
        // 保存输入的相关信息
        oldLoginPassword: '', // 登录密码
        newLoginPassword: '',
        oldFundPass: '', // 资金密码
        newFundPass: ''
      },
      whetherVerify: {
        currentISwitch: '',
        phoneVerifyFlag: true,
        emailVerifyFlag: true,
        googleVerifyFlag: true
      },
      safeVerifyInfo: {
        // 用于开启关闭安全验证的参数，会穿透到安全验证组件中用于发送请求
        smstype: 0,
        type: 0,
        status: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...{
      passwordSafeLevel() {
        let classArr = ['bgl', 'bgm', 'bgh']
        let newClassArr = Array(3).fill('')
        for (var i = 0; i < this.userInfo.safetyLevel; i++) {
          newClassArr[i] = classArr[this.userInfo.safetyLevel - 1]
        }
        return newClassArr
      }
    }
  },
  provide() {
    return {
      modalComp: this.modalComp,
      modalVis: this.modalVis,
      inputInfo: this.inputInfo,
      whetherVerify: this.whetherVerify,
      safeVerifyInfo: this.safeVerifyInfo
    }
  },
  async created() {
    this.updateISwitch()
    updateUserInfo()
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.from = from.name
  //   })
  // },
  mounted() {
    /**
     * + 为了方便调试的代码，调试完毕应该去掉，用于组件加载的时候立即显示某些模态框
     * */
    Object.keys(this.modalVis).forEach((key) => {
      this.modalVis[key] && this.showModalHandle(key)
    })
  },
  methods: {
    updateISwitch() {
      // 初始化手机 谷歌 邮箱的验证状态
      this.whetherVerify.phoneVerifyFlag = this.userInfo.enablePhoneCheck === 1
      this.whetherVerify.emailVerifyFlag = this.userInfo.enableEmailCheck === 1
      this.whetherVerify.googleVerifyFlag =
        this.userInfo.enableGoogleCheck === 1
    },
    showModalHandle(modalType) {
      // 组件动态加载,如果已经加载过则直接显示模态框
      // 判断组件是否已经加载
      if (!this.modalComp[modalType]) {
        this.modalComp[modalType] = modal[modalType]
      }
      this.modalVis[modalType] = true
    },
    iSwitchCompPhoneVerify(isOpen) {
      // 设置请求信息
      // 设置打开还是关闭验证
      if (isOpen) {
        this.safeVerifyInfo.status = 1
        this.safeVerifyInfo.smstype = 9
        this.showModalHandle('openPhoneVerify')
      } else {
        this.safeVerifyInfo.status = 0
        this.safeVerifyInfo.smstype = 10
        this.showModalHandle('openOrCloseVerify')
      }
      this.safeVerifyInfo.type = 0

      // 设置当前正在操作的 i-switch 名称
      this.whetherVerify.currentISwitch = 'phoneVerifyFlag'
    },
    iSwitchCompGoogleVerify(isOpen) {
      if (isOpen) {
        this.safeVerifyInfo.status = 1
        this.safeVerifyInfo.smstype = 13
        this.showModalHandle('openGoogleVerify')
      } else {
        this.safeVerifyInfo.status = 0
        this.safeVerifyInfo.smstype = 14
        this.showModalHandle('openOrCloseVerify')
      }
      this.safeVerifyInfo.type = 1

      this.whetherVerify.currentISwitch = 'googleVerifyFlag'
    },
    iSwitchCompEmailVerify(isOpen) {
      if (isOpen) {
        this.safeVerifyInfo.status = 1
        this.safeVerifyInfo.smstype = 11
        this.showModalHandle('openEmailVerify')
      } else {
        this.safeVerifyInfo.status = 0
        this.safeVerifyInfo.smstype = 12
        this.showModalHandle('openOrCloseVerify')
      }
      this.safeVerifyInfo.type = 2

      this.whetherVerify.currentISwitch = 'emailVerifyFlag'
    }
  },
  watch: {
    userInfo: {
      handler() {
        this.updateISwitch()
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
// .personal-container {
//   width: 100%;
//background: pink;
// }

// .personal {
//background: #fff;
// }

/* %  账户和安全 - 开始  */

.account-info {
  width: 1200px;
  margin: 0 auto;
  padding-top: 60px;
}

.account-info-title-wrap {
  border-bottom: 2px solid #979797;
}

.account-info-title {
  font-size: 24px;
  color: #333;
  font-weight: 500;
}

.account-info-subtitle {
  margin: 20px 0;
}

.last-login-time {
  margin-right: 10px;
}

.goto-safe-log-btn {
  color: #42b3fa;
}

.account-info-alert {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 30px 0;
  border: none; // 该属性复写了组件的边框
}

.account-content {
  margin-top: 10px;
  height: 110px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 30px;
}

.account-content-item {
  height: 50px;
  flex: 1;
}

.account-content-item h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

.account-content-phone,
.account-content-email {
  .l-border(@h: 100%, @l: -1px);
  padding-left: 30px;
}

.go-auth-btn,
.email-verify-btn,
.security-setting-btn-modify {
  color: #42b3fa;
  font-size: 16px;
  text-decoration: none;
}

/* % 账户和安全 - 结束  */

/* & 安全设置 - 开始 */

.security-setting {
  margin-top: 60px;
}

.security-setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ebebeb;
  padding: 18px 0;
}

.security-setting-item label {
  color: #333;
  width: 138px;
  font-size: 16px;
}

.security-setting-item-con {
  width: 700px;
}

.security-setting-option {
  width: 260px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.security-setting-title {
  font-size: 20px;
  color: #333;
}

.security-setting-icon {
  width: 28px;
  height: 28px;
  margin-right: 30px;
}

.security-setting-item-con-tip {
  color: #999;
  font-size: 16px;
}

.security-setting-option-switch {
  margin-left: 15px;
}

.security-setting-item-con {
  display: flex;
  align-items: center;
}

.security-setting-pass-gui {
  display: inline-flex;
  width: 160px;
  justify-content: space-between;
}

.security-setting-pass-txt {
  display: inline-flex;
  margin-left: 15px;
}

.security-setting-pass-txt i {
  font-style: normal;
  font-size: 16px;
  text-align: center;
  line-height: 28px;
  margin-right: 8px;
}

.pass-gui {
  display: block;
  width: 50px;
  height: 4px;
  border-radius: 2px;
  background: #d0d0d0;
}

.txt-low {
  background: #fdefef;
  color: #f5a19e;
}

.txt-middle {
  background: #fef0df;
  color: #fb9b03;
}

.txt-high {
  background: #dbf9eb;
  color: #33d673;
}

/* & 安全设置 - 结束 */

/*. 常用地管理 - 开始 */
.often-area-table {
  width: 100%;
  margin: 50px 0;
  text-align: left;
}

.often-area-table caption {
  border: none;
  text-align: left;
  font-size: 20px;
  color: #333;
}

.often-area-table tr td:last-child {
  text-align: right;
}

.often-area-table th:last-child {
  text-align: right;
}

.often-area-table th {
  font-size: 12px;
  color: #999999;
}

.often-area tr {
  height: 60px;
  border-bottom: 1px solid #ebebeb;
}

.remove-btn {
  color: #ef7370;
}

/*. 常用地管理 - 结束  */

.page-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

/deep/ .page-con {
  .page-base();
}

/* 密码强度的3种颜色 - 开始 */
.bgl {
  background: #f5a19e;
}

.bgm {
  background: #fb9b03;
}

.bgh {
  background: #33d673;
}

/* 密码强度的3种颜色 - 结束 */
</style>
